import { render, staticRenderFns } from "./assignment.vue?vue&type=template&id=00a3905a&scoped=true&"
import script from "./assignment.vue?vue&type=script&lang=js&"
export * from "./assignment.vue?vue&type=script&lang=js&"
import style0 from "./assignment.vue?vue&type=style&index=0&lang=less&"
import style1 from "./assignment.vue?vue&type=style&index=1&id=00a3905a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a3905a",
  null
  
)

export default component.exports